import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { OAuthService } from 'angular-oauth2-oidc';

@Injectable({providedIn: 'root'})
export class RouteGuard implements CanActivate {
  constructor(private oauthService: OAuthService, private router: Router) {
  }

  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    // Wait for the library to finish checking storage/URL
    await this.oauthService.loadDiscoveryDocumentAndTryLogin();

    if (this.oauthService.hasValidAccessToken() && this.oauthService.hasValidIdToken()) {
      return true;
    }
    console.log('RouteGuard: Redirecting to Okta login');
    this.oauthService.initImplicitFlow();
    return false;
  }
}
